import React from "react";
import { ChevronDown } from "lucide-react";

// Whose numbers am I looking at.
//
// Shown only when there is more than one person to choose between, which for a
// rep is never — the API scopes their rows to themselves, so the list has one
// entry and a dropdown would be a control that cannot do anything.
export default function PersonPicker({ people, value, onChange }) {
  if (!people || people.length < 2) return null;
  return (
    <span style={{ position: "relative", display: "inline-flex", alignItems: "center" }}>
      <select value={value || ""} onChange={(e) => onChange(e.target.value)}
              style={{ appearance: "none", padding: "6px 28px 6px 10px", fontSize: 12.5,
                       fontWeight: 600, borderRadius: 8, border: "1px solid var(--c-200)",
                       background: "var(--surface)", color: "var(--c-900)", cursor: "pointer" }}>
        {people.map((p) => (
          <option key={p.employee} value={p.employee}>
            {p.name} — {p.calls.length} call{p.calls.length === 1 ? "" : "s"}
          </option>
        ))}
      </select>
      <ChevronDown size={13} style={{ position: "absolute", right: 9, pointerEvents: "none",
                                      color: "var(--c-500)" }} />
    </span>
  );
}
